<template>
  <div class="search-district">
    <!-- <v-autocomplete v-model="selectedState"
      
      :items="stateList"
      label="New York"
      class="select-state"
      solo></v-autocomplete> -->

    <v-select
      v-model="selectedType"
      class="district-type-selector"
      :items="districtType"
      label="District Type"
      solo
      dense
      height="20"
      @change="changeSearch()"
    ></v-select>

    <v-select
      v-model="mapColumn"
      class="var-type-selector"
      :items="mapColumnOptions"
      label="Map Variable"
      solo
      dense
    ></v-select>


  </div>
</template>
<script>
//TODO: Move this template (and references) to DataDisplay
//https://developers.google.com/maps/documentation/geocoding/overview
//https://docs.mapbox.com/help/how-mapbox-works/geocoding/
import stateList from "../data/StateList";

import { Enums, LegislativeChoropleth } from "../data/Config/Config";
import {EventBus} from "../data/EventBus";

export default {
  name: "DistrictSearch",
  components: {},
  data: function () {
    return {
      stateList: stateList,
      districtType: [
        { text: "US Congress", value: Enums.LEG_BODY.CONGRESS },
        { text: "State Upper House", value: Enums.LEG_BODY.ST_UPPER },
        { text: "State Lower House", value: Enums.LEG_BODY.ST_LOWER },
      ],
    };
  },
  mounted: function () {},
  computed: {
    selectedType: {
      get: function () {
        return this.$store.getters.getDistrictType;
      },
      set: function (newValue) {
        this.$store.commit("setDistrictType", newValue);
      },
    },
    mapColumnOptions: function () {
      let opts = [];

      Object.keys(LegislativeChoropleth.config).forEach((_layer) => {
        // opts.push({text: Choropleth.config[_layer].title, value: _layer});
        opts.push({
          text: LegislativeChoropleth.config[_layer].titleplaintext,
          value: _layer,
        });
      });

      return opts;
    },
    mapColumn: {
      get: function () {
        return this.$store.getters.getMapColumn;
      },
      set: function (newValue) {
        this.$store.commit("setMapColumn", newValue);
      },
    },
    selectedState: {
      get: function () {
        return this.$store.getters.getStateFips;
      },
      set: function (val) {
        this.$store.commit("setStateFips", val);
      },
    },
    districtNumber: {
      get: function () {
        return this.$store.getters.getDistrictNumber;
      },
      set: function (val) {
        this.$store.commit("setDistrictFIPS", val);
      },
    },
  },
  methods: {
    changeSearch: function(){
      EventBus.$emit('change-search',this.selectedType)
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-container {
}
.select-state {
  width: 80%;
  left: 10%;
  position: absolute;
  top: 12px;
  display: inline-block;
  height: 50px;
  z-index: 3;
}

.select-district {
  position: absolute;
  /* margin-left: 60px; */
  margin-top: 0px;
  /* height: 48px; */
  z-index: 3;
  top: 115px;
  padding: 5px;
  border-radius: 5px;
  background: white;
  width: 80%;
  left: 10%;
}

.var-type-selector,
.district-type-selector {
  width: 80%;
  left: 10%;
  top: 0px;
  z-index: 3;
  position: absolute;
}

.var-type-selector {
  top: 42px;
}

.search-district {
  position: absolute;
  margin-top: 30px;
  width: 100%;
}

.l-map {
  z-index: 0;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

